"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var MultiSelectStore_1 = __importDefault(require("Common/MultiSelectStore/MultiSelectStore"));
var SelectionStore = (function () {
    function SelectionStore() {
        var _this = this;
        this.multiSelectStore = new MultiSelectStore_1.default();
        this.isSelected = function (index) {
            return _this.multiSelectStore.isSelected(index);
        };
        this.isSelecting = function (index) {
            return _this._selecting[index];
        };
        this.isOnlySelected = function (index) {
            var selected = _this.selected;
            return selected.length === 1 && selected[0] === index;
        };
        this.setNumberOfVisibleProjects(25);
    }
    SelectionStore.prototype.setNumberOfVisibleProjects = function (num) {
        this._numberOfVisibleProjects = num;
        this._selecting = new Array(num);
        this.multiSelectStore.clearAllSelections();
    };
    Object.defineProperty(SelectionStore.prototype, "selected", {
        get: function () {
            return this.multiSelectStore.sortedIndices;
        },
        enumerable: false,
        configurable: true
    });
    SelectionStore.prototype.setSelecting = function (selecting) {
        var e_1, _a;
        for (var i = 0; i < this._selecting.length; i++) {
            this._selecting[i] = false;
        }
        try {
            for (var selecting_1 = __values(selecting), selecting_1_1 = selecting_1.next(); !selecting_1_1.done; selecting_1_1 = selecting_1.next()) {
                var index = selecting_1_1.value;
                if (index >= 0 && index < this._selecting.length) {
                    this._selecting[index] = true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (selecting_1_1 && !selecting_1_1.done && (_a = selecting_1.return)) _a.call(selecting_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    SelectionStore.prototype.setSelectingToSelected = function (inAdditionToCurrentSelection) {
        if (!inAdditionToCurrentSelection) {
            this.multiSelectStore.clearAllSelections();
        }
        for (var i = 0; i < this._selecting.length; i++) {
            if (this._selecting[i]) {
                this.multiSelectStore.addSelection(i);
                this._selecting[i] = false;
            }
        }
    };
    Object.defineProperty(SelectionStore.prototype, "isAnythingSelected", {
        get: function () {
            return this.multiSelectStore.selectedCount > 0;
        },
        enumerable: false,
        configurable: true
    });
    SelectionStore.prototype.selectIndex = function (index) {
        this.multiSelectStore.addSelection(index);
    };
    SelectionStore.prototype.toggleIndexSelected = function (index) {
        this.multiSelectStore.toggleSelection(index);
    };
    SelectionStore.prototype.deselectAll = function () {
        this.multiSelectStore.clearAllSelections();
    };
    SelectionStore.prototype.selectAll = function () {
        var allIndicesArray = Array.from({ length: this._numberOfVisibleProjects }, function (v, k) { return k; });
        this.multiSelectStore.setSelection(allIndicesArray);
    };
    SelectionStore.prototype.expandSelectionToIndex = function (index) {
        this.multiSelectStore.rangeSelect(index);
    };
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], SelectionStore.prototype, "_selecting", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], SelectionStore.prototype, "selected", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], SelectionStore.prototype, "setSelecting", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SelectionStore.prototype, "setSelectingToSelected", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SelectionStore.prototype, "isAnythingSelected", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], SelectionStore.prototype, "selectIndex", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], SelectionStore.prototype, "toggleIndexSelected", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SelectionStore.prototype, "deselectAll", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SelectionStore.prototype, "selectAll", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], SelectionStore.prototype, "expandSelectionToIndex", null);
    return SelectionStore;
}());
exports.default = SelectionStore;
